import { LinearProgress } from '@mui/material'
import { ArrowDropUp } from '@mui/icons-material'
import styles from './InsightProgressBar.module.scss'

export default function ProgressBarWindow({percent, tag, secondTag, label}){
    const leftKey = Object.keys(tag)[0]
    const rightKey = Object.keys(secondTag)[0]

    return (
        <div className={styles['progressbar-window']}>
            <div>
                <div className={styles['progressbar-tags']}>
                    <p>{tag[leftKey]}</p>
                    <div className={styles['progress-bar']}>
                    <LinearProgress classes={{ colorPrimary: styles['colorPrimary'] }} value={0} variant="determinate" />
                        { label != null ? (
                        <div className={styles['arrow']} style={{ paddingLeft: `calc(${percent}% - 12px)`}}>
                            <ArrowDropUp />
                            <p className={styles['correlation']}>{label.toFixed(2)}</p>
                        </div> ) : null}
                    </div>
                    <p>{secondTag[rightKey]}</p>
                </div>
            </div>
        </div>
    )
}